import OnboardingConfig from "../js/components/configuration/onboardingConfig/OnboardingConfig.react";
export default OnboardingConfig;
